import { PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Menu, Dropdown } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import { t } from '@System/i18n';
import { url } from '@System/routing';

export default function ImportPackageCreateMenu({ children }) {
    const selectedAction = (
        <Menu className="menu-dropdown-action _import-package-create-menu">
            <Menu.Item key={1} className=" mb-3 mb-xl-0">
                <Link to={url.to('import-package.create')}>
                    <Button className="_btn-import-package-create-manual" type={'link'} icon={<PlusCircleOutlined />}>
                        {t('btn.create_import_package_manual')}
                    </Button>
                </Link>
            </Menu.Item>
            <Menu.Item key={2} className=" mb-3 mb-xl-0">
                <Link to={url.to('import-package.create-by-purchase')}>
                    <Button className="_btn-import-package-create-by-purchase" type={'link'} icon={<PlusCircleOutlined />}>
                        {t('btn.create_import_purchase_system')}
                    </Button>
                </Link>
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={selectedAction} trigger={['click']} className="_dropdown-action">
            {children ? (
                children
            ) : (
                <Button icon={<PlusOutlined />} type="primary">
                    {t('btn.create_import_package')}
                </Button>
            )}
        </Dropdown>
    );
}
